<template>
  <p class="form-error">
    <slot/>
  </p>
</template>

<script>
export default {
  name: 'AFormError'
}
</script>

<style scoped>
.form-error {
  margin: 8px 0 0;

  font-style: italic;
  line-height: 1.4;
  color: var(--color-error);
}
</style>
